var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var Header = function () {
	this.$mobileMenu = $( '.mobile-menu' );
	this.$hamburger = $( '.hamburger-icon' );
	this.$searchButtton = $( '.maxulin-icon-search a' );
	this.$searchForm = $( '.search-dropdown' );
	this.$scrollDown = $( 'a.header-scroll-down' );
	this.$headerImage = $( '.header-image' );
};

Header.prototype.init = function () {

	var self = this;
	var $window = $( window );

	// $( '.header-image .header-text' ).bigtext({
	// 	maxfontsize: 75
	// });

	$.fn.scrollToInit( self );

	function resizeBackground() {

		var height = $window.height();

		if ( $( '#wpadminbar' ).length ) {
			height = height - $( '#wpadminbar' ).height();
		}

		self.$headerImage.height( height );
	}

	resizeBackground();

	$( window ).resize( function () {
		if ( $( window ).width() >= 1024 ) {
			resizeBackground();
		}
	} );

	self.$searchButtton.click( function ( e ) {
		e.preventDefault();
		self.$searchForm.slideToggle( '500', 'easeInOutCirc' );
	} );

	self.$hamburger.click( function ( e ) {
		e.preventDefault();
		self.$hamburger.toggleClass( 'open-menu' );
		self.$mobileMenu.toggleClass( 'open-menu' );
	} );

	self.$mobileMenu.on( 'touchmove', function ( e ) {
		e.preventDefault();
	}, false );

	var closeSearch = false;
	$window.resize( function () {
		if ( $( window ).width() < 1024 && ! closeSearch ) {
			self.$searchForm.slideUp( '500', 'easeInOutCirc' );
			closeSearch = true;
		}
		if ( $( window ).width() >= 1024 && closeSearch ) {
			closeSearch = false;
		}
	} );

	self.$scrollDown.click( function ( e ) {

		e.preventDefault();

		var ele = $( this ).closest( 'div' ).next();

		$( 'html, body' ).animate( {
			scrollTop: $( ele ).offset().top - 76
		}, 300 );

		return false;
	} );

	$window.scroll( function () {

		if ( $( this ).scrollTop() > 0 ) {
			self.$scrollDown.addClass( 'hidden' );
		}
		else {
			self.$scrollDown.removeClass( 'hidden' );
		}
	} );

	/*
	function scrollToForm() {
		var target = $( '.module-order-form' ).first();
		var menuHeight = $( '#main-menu' ).height();

		$( 'html,body' ).animate( {
			scrollTop: target.offset().top - ( menuHeight )
		}, 1000 );
	}

	function scrollToNewsletter() {
		var target = $( '.module-mail-signup' ).first();
		var menuHeight = $( '#main-menu' ).height();

		$( 'html,body' ).animate( {
			scrollTop: target.offset().top - ( menuHeight )
		}, 1000 );
	}

	var hashname = window.location.hash.replace( '#', '' );
	if ( hashname && 'bestill' == hashname ) {
		if ( $( '.module-order-form' ).length ) {
			scrollToForm();
		}
	} else if ( hashname && 'nyhetsbrev' == hashname ) {
		if ( $( '.module-mail-signup' ).length ) {
			scrollToNewsletter();
		}
	}


	$( '#main-menu .maxulin-icon-cart a' ).click( function ( e ) {

		if ( ! $( '.module-order-form' ).length ) {
			return;
		}

		e.preventDefault();

		scrollToForm();

		return false;
	} );

	$( '.mobile-menu .maxulin-icon-cart a' ).click( function ( e ) {

		if ( ! $( '.module-order-form' ).length ) {
			return;
		}

		e.preventDefault();

		self.$hamburger.toggleClass( 'open-menu' );
		self.$mobileMenu.toggleClass( 'open-menu' );

		scrollToForm();

		return false;
	} );
	*/

};

/**
 * Get the height of the header bar.
 * @returns {jQuery}
 */
$.fn.getHeaderHeight = function( number ) {
	if ( ! number ) {
		number = 0;
	}
	return $( '#header' ).outerHeight() + number;
};

/**
 * Scroll initially after page load.
 */
$.fn.scrollToInit = function( Header ) {

	// Menu item click event.
	$( 'a' ).click( function( e ) {

		var obj = $( this ),
			id = obj.get( 0 ).hash.replace( 'scroll-', '' ),
			target_element = $( id ),
			is_current_page = obj.get( 0 ).pathname === window.location.pathname;

		// Check if we are on the same page that the link points to
		// Check if we found an element corresponding with an ID corresponding to our hash on the link
		if ( is_current_page && target_element.length ) {

			// Close menu when click on a menu link if the menu is open
			Header.$hamburger.removeClass( 'open-menu' );
			Header.$mobileMenu.removeClass( 'open-menu' );

			// Scroll to element
			$( 'html, body' ).animate( {
				scrollTop: ( target_element.offset().top - $.fn.getHeaderHeight( 25 ) )
			}, 750 );

			// Stop native behaviour
			e.preventDefault();
			return false;

		}

		// Proceed like normal
		return true;

	} );

	/**
	 * Scroll down to target element if we have one.
	 */
	setTimeout( function() {
		// Check if we have a hash in the URL
		var hash = window.location.hash.replace( '#', '' ).replace( 'scroll-', '' );
		if ( hash ) {

			// Look for an element corresponding to that ID
			var id = '#' + hash,
				el = $( id );
			if ( el.length ) {

				// Scroll to element
				$( 'html, body' ).animate( {
					scrollTop: ( el.offset().top - $.fn.getHeaderHeight( 25 ) )
				}, 750 );

			}
		}
	}, 1000 );

};

module.exports = new Header;
